import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import classNames from "classnames";
import PropTypes from "prop-types";
import tinycolor from "tinycolor2";

import Button from "components/Common/Button";
import SvgIcon from "components/Common/SvgIcon";
import { NO_OP_FUNCTION } from "services/helpers";

import colors from "stylesheets/utilities/colors.scss";
import InfoTooltip from "../InfoTooltip";
import "./style.scss";

const BLOCK_NAME = "Tag";

class Tag extends React.Component {
  /**
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.isLong = false;

    this.tagText = React.createRef();
  }

  /**
   * Lifecycle Methods
   */

  /** */
  componentDidMount() {
    const tagTextTotalWidth = this.tagText.current.scrollWidth;
    const tagTextShownWidth = this.tagText.current.clientWidth;

    if (tagTextTotalWidth > tagTextShownWidth) {
      this.isLong = true;
    }
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      customClassName, tag, onClick, removeTag, showAsLine, isSmall, hasIcon
    } = this.props;

    const isLight = tinycolor(tag.color).isLight();


    return (
      <div
        className={classNames(
          BLOCK_NAME,
          {
            [customClassName]: customClassName,
            [`${BLOCK_NAME}--is-light`]: isLight,
            [`${BLOCK_NAME}--line`]: showAsLine,
            [`${BLOCK_NAME}--small`]: isSmall,
            [`${BLOCK_NAME}--icon`]: hasIcon

          }
        )}
        role="presentation"
        style={{ backgroundColor: tag.color }}
        onClick={() => onClick && onClick(tag.name)}
      >
        <div className={`${BLOCK_NAME}__text`} ref={this.tagText}>
          {hasIcon && (
            <SvgIcon
              icon="Star"
              customClassName="ResponseListItem__icons__icon"
              fillColor="currentColor"
              height={13}
            />
          )}
          {!showAsLine && tag.name}
        </div>
        {
          this.isLong && (
            <InfoTooltip
              blurb={tag.name}
              iconDefault="none"
              openOnHover
              absolute
            />
          )
        }
        {removeTag && (
          <Button
            customClassName={`${BLOCK_NAME}__button`}
            onClick={() => removeTag(tag.id)}
            title="Remove Tag"
            fillColor={isLight ? colors.colorBlack : colors.colorWhite}
            icon="NoEntry"
            clear
            small
          />
        )}
      </div>
    );
  }
}

Tag.defaultProps = {
  tag: null,
  customClassName: null,
  isSmall: false,
  showAsLine: false,
  onClick: NO_OP_FUNCTION,
  removeTag: null,
  hasIcon: false
};

Tag.propTypes = {
  /** CSS overrided */
  customClassName: PropTypes.string,
  /** Immutable Tag Record to be rendered */
  tag: ImmutablePropTypes.recordOf({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string
  }),
  /** onClick event handler */
  onClick: PropTypes.func,
  /** Function for deleting a Tag */
  removeTag: PropTypes.func,
  isSmall: PropTypes.bool,
  showAsLine: PropTypes.bool,
  hasIcon: PropTypes.bool
};

export default Tag;
